<template>
  <div class="mb-5">
    <h1 class="is-hidden">Glossar</h1>
    <div class="box">
      <h2 class="has-text-centered">Buchstabe "{{ character }}"</h2>
      <div class="has-overflow-hidden">
        <table class="table is-striped is-hoverable">
          <tbody>
            <tr v-for="(term, index) in terms" :key="index">
              <td class="is-hidden-mobile" v-bind:id="term.term.replace(/\s+/g, '')">
                <strong>{{ term.term }}</strong>
              </td>
              <td class="is-hidden-mobile">
                <p class="mb-3" v-html="term.description"></p>
              </td>
              <td class="is-hidden-tablet has-text-centered">
                <p class="mb-1">
                  <strong>{{ term.term }}</strong>
                </p>
                <p class="mb-3 is-size-7" v-html="term.description"></p>
              </td>
            </tr>
            <tr v-if="terms.length == 0">
              <td>
                <p class="has-text-centered-mobile">
                  Für diesen Buchstaben gibt es aktuell keine Glossar-Einträge.<br>Wenn du etwas vermisst, lass es mich unter <a href="mailto:kontakt@elektrotechnik-rechner.at">kontakt@elektrotechnik-rechner.at</a> wissen.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import * as data from '@/views/glossary/data.js'

export default {
  name: 'GlossaryTable',
  props: {
    character: { type: String, required: true }
  },
  methods: {
    getTerms (character, terms) {
      const termArray = []

      for (let i = 0; i < terms.length; i++) {
        if (terms[i].term.charAt(0) === character) {
          termArray.push(terms[i])
        }
      }

      termArray.sort(function (a, b) {
        const textA = a.term.toUpperCase()
        const textB = b.term.toUpperCase()

        return textA.localeCompare(textB)
      })

      return termArray
    }
  },
  data () {
    return {
      dropdown_active: false,
      terms: null
    }
  },
  created () {
    this.terms = this.getTerms(this.character, data.terms)
  }
}
</script>
